import {LoginContext, User} from "./LoginContextProvider";
import { createContext, useState, useEffect, useContext, useMemo } from "react";
import {Todo} from "./api/";
import {LocalTodoStore} from "./LocalTodoStore";
import {RestTodoStore} from "./RestTodoStore";

interface TodoListContextProviderInterface{
 addTodo: (value: string) => Promise<void>
 remove: (todoId: number) => Promise<void>
 remove_all: () => Promise<void>
 updateTodo: (todoId: number, content: string | null, isDone: boolean | null) => Promise<void>
 list: Todo[]
}

export const TodoListContext = createContext<TodoListContextProviderInterface>({
  addTodo: () => {
    return Promise.resolve()
  },
  remove: () => {
    return Promise.resolve()
  },
  remove_all: () => {
    return Promise.resolve()
  },
  updateTodo: () => {
    return Promise.resolve()
  },
  list: [],
});

function createTodoStore(isLoggedIn: boolean) {
  return isLoggedIn ? new RestTodoStore("") : new LocalTodoStore();
}

export function TodoListContextProvider({ children }) {

  const { loggedUser, isLoggedIn } = useContext(LoginContext);

  const todoStore: LocalTodoStore | RestTodoStore = useMemo(() => {
    return createTodoStore(isLoggedIn);
  }, [isLoggedIn]);

  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(0);

  async function fetchTodos(loggedUser: User | null) {
    if (loggedUser) {
      const todos = await todoStore.getTodos(loggedUser.id);
      setList(todos);
    } else {
      const todos = await todoStore.getTodos(0);
      setList(todos);
    }
  }
 
  useEffect(() => {
      fetchTodos(loggedUser);
  }, [refresh, loggedUser]);

  const updateTodo = async (todoId: number, content: string | null, isDone: boolean | null) => {
    await todoStore.updateTodo(todoId, content, isDone);
    setRefresh((r) => r + 1);
  };

  const remove = async (todoId: number) => {
    await todoStore.remove(todoId);
    setRefresh((r) => r + 1);
  };

  const remove_all = async () => {
    await todoStore.remove_all();
    setRefresh((r) => r + 1);
  };

  const addTodo = async (value: string) => {
    console.log(value)
    await todoStore.addTodo(value);
    setRefresh((r) => r + 1);
  };

  return <TodoListContext.Provider value={{ list, updateTodo, remove, addTodo, remove_all }}>{children}</TodoListContext.Provider>;
}
